import React from 'react';
import { Badge, Icon } from 'AWS-UI-Components-React';
import { SimulationStatusTypes } from '../../constants/constants';

export function displayFlag(flag, positiveIconText, negativeIconText) {
  if (flag) {
    return (
      <span className="awsui-util-status-positive">
          <Icon name="status-positive" /> {positiveIconText ? positiveIconText : 'Yes'}
        </span>
    );
  } else {
    return (
      <span className="awsui-util-status-negative">
          <Icon name="status-negative" /> {negativeIconText ? negativeIconText : 'No'}
        </span>
    );
  }
}

export function displayStatusBadge(simulation) {
  let color = 'blue';
  let status = simulation.latestStatus;
  if (status && status.endsWith(SimulationStatusTypes.FAILED)) {
    color = 'red';
  } else if (status === SimulationStatusTypes.DONE) {
    color = 'green';
  }

  return (<div><Badge color={ color } content={ status } /></div>);
}

export function sorter(a, b) {
  if (a.timestamp === b.timestamp) {
    return 0;
  } else {
    return a.timestamp < b.timestamp ? 1 : -1;
  }
}

export function getFilteringOptions(simulations) {
  let nameOptions = new Set();
  let idOptions = new Set();
  let userOptions = new Set();
  let statusOptions = new Set();
  let dateOptions = new Set();
  if (simulations) {
    simulations.forEach(simulation => {
      if (simulation.name) {
        nameOptions.add(simulation.name);
      }
      if (simulation.id) {
        // Keep numeric: a stringified token would never match the numeric row id.
        idOptions.add(simulation.id);
      }
      if (simulation.user) {
        userOptions.add(simulation.user);
      }
      if (simulation.latestStatus) {
        statusOptions.add(simulation.latestStatus);
      }
      if (simulation.timestamp) {
        dateOptions.add(simulation.timestamp.substr(0, 10));
      }
    });
  }
  return [
    {
      groupValuesLabel: 'Name Values',
      propertyKey: 'name',
      propertyLabel: 'Name',
      values: Array.from(nameOptions),
    },
    {
      groupValuesLabel: 'ID Values',
      propertyKey: 'id',
      propertyLabel: 'ID',
      values: Array.from(idOptions),
    },
    {
      groupValuesLabel: 'Owner Values',
      propertyKey: 'user',
      propertyLabel: 'Owner',
      values: Array.from(userOptions),
    },
    {
      groupValuesLabel: 'Status Values',
      propertyKey: 'latestStatus',
      propertyLabel: 'Status',
      values: Array.from(statusOptions),
    },
    {
      groupValuesLabel: 'Date Option Values',
      propertyKey: 'timestamp',
      propertyLabel: 'Creation Date',
      values: Array.from(dateOptions),
    },
  ];
}

function matchesFilteringToken(item, token) {
  const value = item[token.propertyKey];
  let matches;
  if (token.isFreeText || !token.propertyKey) {
    const searchText = token.value.toLowerCase();
    const searchableKeys = token.propertyKey ? [token.propertyKey] : Object.keys(item);
    matches = searchableKeys.some(
      (key) => typeof item[key] === 'string' && item[key].toLowerCase().indexOf(searchText) !== -1
    );
  } else if (token.propertyKey === 'timestamp') {
    // Creation Date is offered as a calendar day, while the simulation carries a full ISO-8601 instant.
    matches = typeof value === 'string' && value.startsWith(token.value);
  } else {
    matches = value === token.value;
  }
  return token.negated ? !matches : matches;
}

export function simulationFilteringFunction(item, tokens, operation) {
  if (!tokens || !tokens.length) {
    return true;
  }
  return operation === 'or'
    ? tokens.some((token) => matchesFilteringToken(item, token))
    : tokens.every((token) => matchesFilteringToken(item, token));
}

export function millisToMinutesAndSeconds(millis) {
  const minutes = Math.floor(millis / 60000);
  const seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}



// WEBPACK FOOTER //
// ./src/components/simulator/simulator_utils.jsx